import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import {MatDividerModule} from '@angular/material/divider';
import { CardModule } from '../../service/card/card.module';
import { CapabilityCardModule } from 'src/app/components/capability-card/capability-card.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from "@angular/material/expansion";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormModule } from 'src/app/components/dynamic-form/dynamic-form.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { QuestionnaireSummaryModule } from 'src/app/components/questionnaire-summary/questionnaire-summary.module';
import { UpdateResourceConfigurationComponent } from './update-resource-configuration.component';
import { MatTabsModule } from '@angular/material/tabs';
@NgModule({
  declarations: [
    UpdateResourceConfigurationComponent
  ],
  imports: [
    CommonModule,
    BreadcrumbModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    CardModule,
    CapabilityCardModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    ReactiveFormsModule,
    FormsModule,
    DynamicFormModule,
    ErrorModule,
    QuestionnaireSummaryModule,
    MatTabsModule
  ]
})
export class UpdateResourceConfigurationModule {
}
